import { StationChainStatus } from '@/api/generated/schemas';

/** Pořadí stavů trasy v segmentovaném přepínači (Koncept · Aktivní · Archivní). */
export const STATION_CHAIN_STATUS_ORDER: StationChainStatus[] = [
  StationChainStatus.Draft,
  StationChainStatus.Active,
  StationChainStatus.Archived,
];
